import { render, staticRenderFns } from "./ContentSider.vue?vue&type=template&id=7a6455d6&scoped=true&"
import script from "./ContentSider.vue?vue&type=script&lang=js&"
export * from "./ContentSider.vue?vue&type=script&lang=js&"
import style0 from "./ContentSider.vue?vue&type=style&index=0&id=7a6455d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6455d6",
  null
  
)

export default component.exports